import { IGeneric, IAny } from '@msdyn365-commerce/core';
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import axios from 'axios';
import { getZipCode } from '../Utilities/get-zipcode';

/**
 * GetSociData Input Action
 */
export class GetSociDataInput implements Msdyn365.IActionInput {
    public searchradius?: number | undefined;
    public searchLimit?: number | undefined;
    public zipCode?: string | undefined;
    constructor(searchradius?: number | undefined, searchLimit?: number | undefined, zipCode?: string | undefined) {
        this.searchradius = searchradius;
        this.searchLimit = searchLimit;
        this.zipCode = zipCode;
    }

    public getCacheKey = () => `SociLocations-${this.zipCode}`;
    public getCacheObjectType = () => 'SociLocations';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<IGeneric<IAny>>): Msdyn365.IActionInput => {
    return new GetSociDataInput(args?.config?.lookupRadius, args?.config?.maxNoOfFranchise ?? 4);
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function getSociData(input: GetSociDataInput, ctx: Msdyn365.IActionContext): Promise<any> {
    try {
        const zipCode = input?.zipCode ? input.zipCode : getZipCode(ctx);
        if (!zipCode) {
            return null;
        }
        let geoLoc = [];
        if(/^[0-9]+$/.test(zipCode)){
            geoLoc = [
                {
                    "postalcode": zipCode
                }
            ];
        } else{
            geoLoc = [
                {
                    "state": zipCode,
                    "city": zipCode
                }
            ];
        }
        const response = await axios.post(`https://api.slippymap.com/rest/locatorsearch`, {
            "request": {
                "appkey": "F147ADC0-8099-11EC-AC1B-273DC403F339",
                "formdata": {
                    "dataview": "store_default",
                    "limit": input.searchLimit ?? 4,
                    "geolocs": {
                        "geoloc": geoLoc
                    },
                    "searchradius": input.searchradius?.toString() ?? "50"
                }
            }
        }
            , {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        if (response.data) {
            return response.data;
        }
        else { return null; }
    } catch (e) {
        //   will be removed after unit test and deployment on lower environment
        console.log('error for soci api', e);
        return null;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<{}>>getSociData,
    id: 'GetSociData',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
